var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLightningOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40601 2.852C8.50277 2.60077 8.67349 2.38482 8.89561 2.23269C9.11773 2.08056 9.38079 1.99942 9.65001 2H18.166C19.093 2 19.736 2.922 19.418 3.792L17.324 9.5H22.161C23.339 9.5 23.938 10.916 23.118 11.762L9.78401 25.503C8.64401 26.678 6.67801 25.62 7.03101 24.021L8.69101 16.5H5.91701C5.60549 16.4999 5.29867 16.424 5.02312 16.2786C4.74757 16.1333 4.51159 15.923 4.33559 15.666C4.1596 15.409 4.0489 15.1129 4.01308 14.8034C3.97726 14.494 4.0174 14.1805 4.13001 13.89L8.40601 2.852Z",
    fill: "#FFD400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLightningOn);
export default __webpack_public_path__ + "static/media/ic-lightning-on.f935e6490f74925dbeb5a38a9d9cd6a1.svg";
export { ForwardRef as ReactComponent };